import Navbar from "@/components/Navbar";
import TopBar from "@/components/TopBar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Leadership from "@/components/Leadership";
import Workforce from "@/components/Workforce";
import WorkforceAvailable from "@/components/WorkforceAvailable";
import Services from "@/components/Services";
import ElectroMechanicalGallery from "@/components/ElectroMechanicalGallery";
import Projects from "@/components/Projects";
import Vision2030 from "@/components/Vision2030";
import Milestones from "@/components/Milestones";
import Certifications from "@/components/Certifications";
import Testimonials from "@/components/Testimonials";
import Branches from "@/components/Branches";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background" data-testid="home-page">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Leadership />
        <Workforce />
        <WorkforceAvailable />
        <Services />
        <ElectroMechanicalGallery />
        <Projects />
        <Vision2030 />
        <Milestones />
        <Certifications />
        <Clients />
        <Testimonials />
        <Branches />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
